import { faLaptopHouse } from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Button,
  Form,
  ListGroup,
  Col,
  Row,
  Spinner,
  Nav,
} from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import ContentLoader from "react-content-loader";
import { toast } from "react-toastify";
import { PortfolioDashboard } from "../../../Common/Services/PortfolioDashboard";
import MetricRightPanel from "../components/MetricRightPanel";
import CustomMetricRightPanel from "../components/CustomMetricRightPanel";
import _ from "lodash";
import { calculateHeight, LayoutTypes, updateLayout } from "../layoutConfig";
import { MultiSelectCustomCard } from "../components/MultiSelectCustomCard";

function searchItemsByTitle(items, searchTerm) {
  if (!Array.isArray(items)) {
    throw new Error("First argument must be an array");
  }
  if (typeof searchTerm !== "string") {
    throw new Error("Search term must be a string");
  }

  // Convert searchTerm to lowercase to make search case-insensitive
  const lowerCaseSearchTerm = searchTerm.toLowerCase();

  return items.filter((item) => {
    // Check if item has a title property and it’s a string
    if (item && typeof item.paramDisplayName === "string") {
      // Convert title to lowercase and check for partial match
      return (
        item.paramDisplayName.toLowerCase().includes(lowerCaseSearchTerm) ||
        item.paramDescrp.toLowerCase().includes(lowerCaseSearchTerm)
      );
    }
    return false;
  });
}

const dummyList = [1, 2, 3, 4, 5, 6, 7, 8, 9];

function MetricModal({
  isMetricEdit,
  metricItem,
  show,
  handleClose,
  x = 0,
  y = 0,
  handleSavePositions,
  dashboardId,
  unsavedChanges,
  layout,
  selectedLayout,
}: any) {
  const listItemRefs = useRef(new Map());
  const [selectedMetric, setSelectedMetric] = useState<any>(null);
  const [metricList, setMetricList] = useState<any>([]);
  const [filteredMetricList, setFilteredMetricList] = useState<any>([]);
  const [metricListLoading, setMetricListLoading] = useState<any>(false);
  const [chartType, setChartType] = useState<any>(null); // default chart type
  const [searchTerm, setSearchTerm] = useState("");
  const [cardData, setCardData] = useState<any>(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState("quickCards");
  const [filters, setFilters] = useState<any>({});

  const [selectedAccountType, setSelectedAccountType] = useState<any>([]);
  const [selectedMainGroup, setSelectedMainGroup] = useState<any>([]);
  const [selectedSubGroup1, setSelectedSubGroup1] = useState<any>([]);
  const [selectedSubGroup2, setSelectedSubGroup2] = useState<any>([]);
  const [selectedSubGroup3, setSelectedSubGroup3] = useState<any>([]);
  const [selectedCoa, setSelectedCoa] = useState<any>([]);

  const [filteredMainGroups, setFilteredMainGroups] = useState<any>([]);
  const [filteredSubGroup1, setFilteredSubGroup1] = useState<any>([]);
  const [filteredSubGroup2, setFilteredSubGroup2] = useState<any>([]);
  const [filteredSubGroup3, setFilteredSubGroup3] = useState<any>([]);
  const [filteredCoa, setFilteredCoa] = useState<any>([]);
  const [customMetricListLoading, setCustomMetricListLoading] = useState<any>(false);
  const [customMatricCards, setCustomMatricCards] = useState<any>([]);

  // Store original values for each field
  const [originalValues, setOriginalValues] = useState<any>({
    cardId: null,
    chartType: null,
    chartTitle: selectedMetric?.paramDisplayName || "",
    chartComparison: [],
    showOnly: null,
    groupingValue: null
  });

  useEffect(() => {
    setOriginalValues({
      cardId: null,
      chartType: null,
      chartTitle: selectedMetric?.paramDisplayName || "",
      chartComparison: [],
      showOnly: null,
      groupingValue: null
    });
  }, [selectedMetric]);

  // Effect to handle scrolling when scrollToId changes
  useEffect(() => {
    if (
      !metricListLoading &&
      metricList.length > 0 &&
      metricItem &&
      !metricItem.isCustom &&
      listItemRefs.current.has(metricItem.parameter.id)
    ) {
      const element = listItemRefs.current.get(metricItem.parameter.id);
      element?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (
      metricItem &&
      metricItem.isCustom) {
      setActiveTab("custom");
    }
  }, [metricListLoading, metricList, metricItem, listItemRefs]);

  useEffect(() => {
    if (metricItem && metricList && !metricItem.isCustom) {
      const targetIndex = metricList.findIndex(
        (item) => item.id === metricItem.parameter.id
      );

      setChartType(metricItem.cardType);
      const _SelectedItem = metricList.find(
        (item) => item.id == metricItem.parameter.id
      );

      setSelectedMetric({ ..._SelectedItem, isEdit: true });

      // if (targetIndex !== -1 && listContainerRef.current) {
      //   const listItems = listContainerRef.current.children;
      //   const targetItem = listItems[targetIndex];

      //   if (targetItem) {
      //     targetItem.scrollIntoView({ behavior: "smooth", block: "nearest" });
      //   }
      // }
    }

    // setOriginalValues({
    //   chartTitle: metric?.paramDisplayName || "",
    //   chartComparison: [],
    //   showOnly: null,
    // });
  }, [metricItem, metricList]);

  useEffect(() => {
   if (metricItem && metricItem.isCustom && metricItem.dashboardCustomMetricParameter) {     
      const param = metricItem.dashboardCustomMetricParameter;

      const parseIds = (value: string | null) =>
        value ? value.split(',').map((v) => v.trim()) : [];

      const accountTypeIds = parseIds(param.accoutType);
      const mainGroupIds = parseIds(param.mainGroup);
      const subGroupOneIds = parseIds(param.subGroupOne);
      const subGroupTwoIds = parseIds(param.subGroupTwo);
      const subGroupThreeIds = parseIds(param.subGroupThree);
      const coaIds = parseIds(param.coa);
  
      setSelectedAccountType(getMatchingItems(filters.accountTypeFilters || [], accountTypeIds));
      setSelectedMainGroup(getMatchingItems(filters.mainGroupFilters || [], mainGroupIds));
      setSelectedSubGroup1(getMatchingItems(filters.subGroup1Filters || [], subGroupOneIds));
      setSelectedSubGroup2(getMatchingItems(filters.subGroup2Filters || [], subGroupTwoIds));
      setSelectedSubGroup3(getMatchingItems(filters.subGroup3Filters || [], subGroupThreeIds));
      setSelectedCoa(getMatchingItems(filters.coaFilters || [], coaIds));
    }
  }, [metricItem, filters]);

  const getMatchingItems = (list: any[] = [], ids: string[] = []) => {  
    const result = list.filter((item) => ids.includes(item.id?.toString()));
    return result;
  };

  useEffect(() => {
    // Check if any field has unsaved changes, using deep comparison for arrays

    if (cardData) {
      setHasUnsavedChanges(
        cardData?.chartTitle !== originalValues?.chartTitle ||
          !_.isEqual(
            cardData?.chartComparison,
            originalValues?.chartComparison
          ) ||
          !_.isEqual(cardData?.showOnly, originalValues?.showOnly)
      );
    }
  }, [cardData, originalValues]);

  const UnsavedChanges = (callBack = () => {}) => {
    confirmAlert({
      title: "Unsaved Changes",
      message:
        "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            // Reset fields to original values
            callBack();
          },
        },
        {
          label: "No",
          onClick: () => setHasUnsavedChanges(true),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  };

  const getMertricList = () => {
    setMetricListLoading(true);
    PortfolioDashboard.GetDashboardParameters()
      .then((result) => {
        setMetricList(result);
        setFilteredMetricList(result);
      })
      .catch((err) => {
        setMetricList([]);
        setFilteredMetricList([]);
      })
      .finally(() => {
        setMetricListLoading(false);
      });
  };

  useEffect(() => {
    if (show) {
      getMertricList();
    }
  }, [show]);

  useEffect(() => {
    if (activeTab === "custom") {
      getCustomFilterList();
      getCustomMatricCards();
    }
  }, [activeTab]);

  const getCustomFilterList = () => {
    setCustomMetricListLoading(true);
    PortfolioDashboard.GetCustomFilterList()
      .then((result) => {
        if (result.success) {
          setFilters(result.result);
          setFilteredMainGroups(result.result.mainGroupFilters);
          setFilteredSubGroup1(result.result.subGroup1Filters);
          setFilteredSubGroup2(result.result.subGroup2Filters);
          setFilteredSubGroup3(result.result.subGroup3Filters);
          setFilteredCoa(result.result.coaFilters);
          // setFilteredMetricList(result);
        }
      })
      .catch((err) => {
        setFilters({});
        // setFilteredMetricList([]);
      })
      .finally(() => {
        setCustomMetricListLoading(false);
      });
  };

  const getCustomMatricCards = () => {
    PortfolioDashboard.GetCustomMatricCards()
      .then((result) => {
        if (result.success) {
          setCustomMatricCards(result.result);
        }
      })
      .catch((err) => {
        setCustomMatricCards([]);
      })
      .finally(() => {
        // setCustomMetricListLoading(false);
      });
  };

  // Filter MainGroup based on AccountType
  useEffect(() => {
    const accountTypeIds = selectedAccountType.map((item) => item.id);

    const mainGroups =
      selectedAccountType.length > 0
        ? filters.mainGroupFilters?.filter((group) =>
          accountTypeIds.includes(group.accountType)
        )
        : filters.mainGroupFilters || [];

    setFilteredMainGroups(mainGroups);
    // clearSelections();
  }, [selectedAccountType, filters.mainGroupFilters]);

  // Filter SubGroup1 based on AccountType + MainGroup
  useEffect(() => {
    const accountTypeIds = selectedAccountType.map((item) => item.id);
    const mainGroupIds = selectedMainGroup.map((item) => item.id);

    let subGroup1 = filters.subGroup1Filters || [];

    if (selectedAccountType.length > 0) {
      subGroup1 = subGroup1.filter((item) =>
        accountTypeIds.includes(item.accountType)
      );
    }
    if (selectedMainGroup.length > 0) {
      subGroup1 = subGroup1.filter((item) =>
        mainGroupIds.includes(item.mainGroupId.toString())
      );
    }

    setFilteredSubGroup1(subGroup1);
    // setSelectedSubGroup1([]);
    // setSelectedSubGroup2([]);
    // setSelectedSubGroup3([]);
    // setSelectedCoa([]);
  }, [
    selectedAccountType,
    selectedMainGroup,
    filters.subGroup1Filters,
  ]);

  // Filter SubGroup2 based on AccountType + MainGroup + SubGroup1
  useEffect(() => {
    const accountTypeIds = selectedAccountType.map((item) => item.id);
    const mainGroupIds = selectedMainGroup.map((item) => item.id);
    const subGroup1Ids = selectedSubGroup1.map((item) => item.id);

    let subGroup2 = filters.subGroup2Filters || [];

    if (selectedAccountType.length > 0) {
      subGroup2 = subGroup2.filter((item) =>
        accountTypeIds.includes(item.accountType)
      );
    }
    if (selectedMainGroup.length > 0) {
      subGroup2 = subGroup2.filter((item) =>
        mainGroupIds.includes(item.mainGroupId.toString())
      );
    }
    if (selectedSubGroup1.length > 0) {
      subGroup2 = subGroup2.filter((item) =>
        subGroup1Ids.includes(item.subGroup1Id.toString())
      );
    }

    setFilteredSubGroup2(subGroup2);
    // setSelectedSubGroup2([]);
    // setSelectedSubGroup3([]);
    // setSelectedCoa([]);
  }, [
    selectedAccountType,
    selectedMainGroup,
    selectedSubGroup1,
    filters.subGroup2Filters,
  ]);

  // Filter SubGroup3 based on all above
  useEffect(() => {
    const accountTypeIds = selectedAccountType.map((item) => item.id);
    const mainGroupIds = selectedMainGroup.map((item) => item.id);
    const subGroup1Ids = selectedSubGroup1.map((item) => item.id);
    const subGroup2Ids = selectedSubGroup2.map((item) => item.id);

    let subGroup3 = filters.subGroup3Filters || [];

    if (selectedAccountType.length > 0) {
      subGroup3 = subGroup3.filter((item) =>
        accountTypeIds.includes(item.accountType)
      );
    }
    if (selectedMainGroup.length > 0) {
      subGroup3 = subGroup3.filter((item) =>
        mainGroupIds.includes(item.mainGroupId.toString())
      );
    }
    if (selectedSubGroup1.length > 0) {
      subGroup3 = subGroup3.filter((item) =>
        subGroup1Ids.includes(item.subGroup1Id.toString())
      );
    }
    if (selectedSubGroup2.length > 0) {
      subGroup3 = subGroup3.filter((item) =>
        subGroup2Ids.includes(item.subGroup2Id.toString())
      );
    }

    setFilteredSubGroup3(subGroup3);
    // setSelectedSubGroup3([]);
    // setSelectedCoa([]);
  }, [
    selectedAccountType,
    selectedMainGroup,
    selectedSubGroup1,
    selectedSubGroup2,
    filters.subGroup3Filters,
  ]);

  // Filter COA based on all levels
  useEffect(() => {
    let filtered = filters.coaFilters || [];

    if (selectedAccountType.length > 0) {
      const ids = selectedAccountType.map((i) => i.id);
      filtered = filtered.filter((c) => ids.includes(c.accountType));
    }
    if (selectedMainGroup.length > 0) {
      const ids = selectedMainGroup.map((i) => i.id);
      filtered = filtered.filter((c) => ids.includes(c.mainGroupId.toString()));
    }
    if (selectedSubGroup1.length > 0) {
      const ids = selectedSubGroup1.map((i) => i.id);
      filtered = filtered.filter((c) => ids.includes(c.subGroup1Id.toString()));
    }
    if (selectedSubGroup2.length > 0) {
      const ids = selectedSubGroup2.map((i) => i.id);
      filtered = filtered.filter((c) => ids.includes(c.subGroup2Id.toString()));
    }
    if (selectedSubGroup3.length > 0) {
      const ids = selectedSubGroup3.map((i) => i.id);
      filtered = filtered.filter((c) => ids.includes(c.subGroup3Id.toString()));
    }

    setFilteredCoa(filtered);
    // setSelectedCoa([]);
  }, [
    selectedAccountType,
    selectedMainGroup,
    selectedSubGroup1,
    selectedSubGroup2,
    selectedSubGroup3,
    filters.coaFilters,
  ]);

  // const clearSelections = () => {
  //   setSelectedMainGroup([]);
  //   setSelectedSubGroup1([]);
  //   setSelectedSubGroup2([]);
  //   setSelectedSubGroup3([]);
  //   setSelectedCoa([]);
  // }

  useEffect(() => {
    const results = searchItemsByTitle(metricList, searchTerm);
    setFilteredMetricList(results);
  }, [searchTerm]);

  const handleMetricSelect = (metric) => {
    // if (hasUnsavedChanges) {
    //   UnsavedChanges(() => {
    //     setSelectedMetric(metric);
    //     setChartType(metric.defaultType || null);
    //     setCardData(null);
    //     setHasUnsavedChanges(false);
    //   });
    // } else {

    const isEdit = metricItem ? metric.id == metricItem?.parameter?.id : false;
    const cardType = metricItem?.cardType || metric?.defaultType || null;

    setSelectedMetric({ ...metric, isEdit });
    setChartType(cardType);
    setCardData(null);
    setHasUnsavedChanges(false);
    // }
  };

  const resetData = () => {
    setSelectedMetric(null);
    setMetricList([]);
    setFilteredMetricList([]);
    setMetricListLoading(false);
    setCustomMetricListLoading(false);
    setChartType(null);
    setSearchTerm("");
    setCardData(null);
  };

  const closeModal = (isSave = false) => {
    if (!isSave && hasUnsavedChanges) {
      UnsavedChanges(() => {
        resetData();
        handleClose();
        setHasUnsavedChanges(false);
      });
    } else {
      resetData();
      handleClose(isSave);
      setHasUnsavedChanges(false);
    }

    // resetData();
    // handleClose();
  };

  const AddToDashboard = () => {
    if (cardData) {
      const baseRequestData: any = {
        DashboardId: dashboardId,
        Title: cardData?.chartTitle,
        CardId: cardData?.cardId,
        ColumnNo: Math.round(x),
        RowNo: Math.round(y),
        ComparisionCardId: cardData?.chartComparison?.map((item) => item.id),
        ShowOnly: cardData?.showOnly?.value,
        IsCustom: activeTab === "custom" ? true : false,
      };

      const customFields = activeTab === "custom" ? {       
        GroupId: cardData?.groupingValue?.id,
        AccountType: selectedAccountType?.map((item) => item.id.toString()),
        MainGroup: selectedMainGroup?.map((item) => item.id.toString()),
        SubgroupOne: selectedSubGroup1?.map((item) => item.id.toString()),
        SubgroupTwo: selectedSubGroup2?.map((item) => item.id.toString()),
        SubgroupThree: selectedSubGroup3?.map((item) => item.id.toString()),
        Coa: (selectedCoa && selectedCoa.length > 0
          ? selectedCoa
          : filteredCoa
        )?.map(item => item.id.toString())
      } : {};
      
      const requestData = {
        ...baseRequestData,
        ...customFields
      };

      if (isMetricEdit && metricItem) {
        requestData.WidgetId = metricItem?.id;
        requestData.ColumnNo = metricItem.columnNo;
        requestData.RowNo = metricItem.rowNo;
      }

      setIsSubmitting(true);

      PortfolioDashboard.SaveDashboard(requestData)
        .then((result) => {
          setIsSubmitting(false);
          closeModal(true);
          if (result.success) {
            let message = "Card added to Dashbboard.";
            if (isMetricEdit) {
              message = "Card updated to Dashbboard.";
            }
            toast.success(message, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          } else {
            toast.error(result.result, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          }
        })
        .catch((error) => {
          toast.success("Something went wrong.", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          console.log(error);
        });
    }
  };

  const handleAddToDashboard = () => {
    // Call API
    if (isMetricEdit) {
      const layoutType = LayoutTypes[selectedLayout - 1];
      const { cols, partitions } = layoutType;
      const maxColumnIndex = partitions.length - 1;
      const columnNo = Math.min(metricItem?.columnNo, maxColumnIndex);

      let columnWidth = partitions[columnNo]; // Width of the current column
      const cardHeight = calculateHeight(
        columnWidth,
        cardData.chartType.toLowerCase() == "number" ? 1 : 3
      );
      const updatedLayoutList = updateLayout(
        layout,
        { ...metricItem, cardHeight: cardHeight },
        selectedLayout
      );
      handleSavePositions(
        () => {
          AddToDashboard();
        },
        false,
        updatedLayoutList
      );
    } else if (unsavedChanges) {
      handleSavePositions(() => {
        AddToDashboard();
      }, false);
    } else {
      AddToDashboard();
    }

    // if(unsavedChanges){
    //   handleSavePositions(()=>{AddToDashboard()}, false)
    // }
    // else{
    //   AddToDashboard()
    // }
  };

  return (
    <Modal
      show={show}
      onHide={closeModal}
      size="xl"
      dialogClassName="modal-90w"
      className="dashboard-portfolio-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Metric Card Library</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* First Row - Tabs + Configure Header */}
        <Row className="height-100">
          <Col md={3} className="border-end left-panel px-0">
            <div className="navigation-area d-flex align-items-end">
              <Nav
                variant="tabs"
                activeKey={activeTab}
                onSelect={(k) => {
                  if (k) setActiveTab(k);
                }}
              >
                <Nav.Item>
                  <Nav.Link eventKey="quickCards">Quick Cards</Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                  <Nav.Link eventKey="custom">Custom</Nav.Link>
                </Nav.Item> */}
              </Nav>
            </div>

            <div className="chart-row tab-scroller">
              {activeTab === "quickCards" && (
                <>
                  <div className="search-box">
                    <Form.Control
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      maxLength={50}
                    />
                  </div>
                  <ListGroup>
                    {metricListLoading
                      ? dummyList.map((item) => (
                          <ContentLoader
                            key={item}
                            viewBox="0 0 100% 120" // Adjusting the height in viewBox to 90
                            style={{
                              width: "100%",
                              height: "120px",
                              margin: "5px 0px",
                            }} // Setting fixed height to 90px
                          >
                            {/* Only SVG shapes */}
                            <rect
                              x="0"
                              y="0"
                              rx="5"
                              ry="5"
                              width="100%"
                              height="120"
                            />{" "}
                          </ContentLoader>
                        ))
                      : filteredMetricList.length > 0 &&
                        filteredMetricList.map((metric) => (
                          <ListGroup.Item
                            key={metric.id}
                            action
                            onClick={() => handleMetricSelect(metric)}
                            ref={(el) => {
                              if (el) {
                                listItemRefs.current.set(metric.id, el);
                              } else {
                                listItemRefs.current.delete(metric.id);
                              }
                            }}
                            active={metric?.id === selectedMetric?.id}
                          >
                            <h5 className="font-weight-bold">
                              {metric.paramDisplayName}
                            </h5>
                            <p className="text-muted">{metric.paramDescrp}</p>
                          </ListGroup.Item>
                        ))}
                  </ListGroup>
                </>
              )}
              {activeTab === "custom" && (
                <div className="space-y-4 custom-metric">
                  <div className="ttl-sec">
                    <div className="ttl">Card Data</div>
                    <div className="desc d-flex">
                      <div>Use the fields below to filter the data.</div>
                      <div className="ml-auto">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.00065 0.333496C3.32065 0.333496 0.333984 3.32016 0.333984 7.00016C0.333984 10.6802 3.32065 13.6668 7.00065 13.6668C10.6807 13.6668 13.6673 10.6802 13.6673 7.00016C13.6673 3.32016 10.6807 0.333496 7.00065 0.333496ZM7.00065 12.3335C4.06065 12.3335 1.66732 9.94016 1.66732 7.00016C1.66732 4.06016 4.06065 1.66683 7.00065 1.66683C9.94065 1.66683 12.334 4.06016 12.334 7.00016C12.334 9.94016 9.94065 12.3335 7.00065 12.3335ZM6.33398 9.66683H7.66732V11.0002H6.33398V9.66683ZM7.40732 3.02683C6.03398 2.82683 4.82065 3.6735 4.45398 4.88683C4.33398 5.2735 4.62732 5.66683 5.03398 5.66683H5.16732C5.44065 5.66683 5.66065 5.4735 5.75398 5.22016C5.96732 4.62683 6.60065 4.22016 7.28732 4.36683C7.92065 4.50016 8.38732 5.12016 8.33398 5.76683C8.26732 6.66016 7.25398 6.8535 6.70065 7.68683C6.70065 7.6935 6.69398 7.6935 6.69398 7.70016C6.68732 7.7135 6.68065 7.72016 6.67398 7.7335C6.61398 7.8335 6.55398 7.94683 6.50732 8.06683C6.50065 8.08683 6.48732 8.10016 6.48065 8.12016C6.47398 8.1335 6.47398 8.14683 6.46732 8.16683C6.38732 8.3935 6.33398 8.66683 6.33398 9.00016H7.66732C7.66732 8.72016 7.74065 8.48683 7.85398 8.28683C7.86732 8.26683 7.87398 8.24683 7.88732 8.22683C7.94065 8.1335 8.00732 8.04683 8.07398 7.96683C8.08065 7.96016 8.08732 7.94683 8.09398 7.94016C8.16065 7.86016 8.23398 7.78683 8.31398 7.7135C8.95399 7.10683 9.82065 6.6135 9.64065 5.34016C9.48065 4.18016 8.56732 3.20016 7.40732 3.02683Z"
                            fill="#2CAF92"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  {customMetricListLoading
                    ? dummyList.map((item) => (
                        <ContentLoader
                          key={item}
                          viewBox="0 0 100% 120" // Adjusting the height in viewBox to 90
                          style={{
                            width: "100%",
                            height: "120px",
                            margin: "5px 0px",
                          }} // Setting fixed height to 90px
                        >
                          {/* Only SVG shapes */}
                          <rect
                            x="0"
                            y="0"
                            rx="5"
                            ry="5"
                            width="100%"
                            height="120"
                          />{" "}
                        </ContentLoader>
                      ))
                    : filters && (
                        <div className="fltr-sec">
                          <div className="group">
                            <label>
                              Account Type <span>(Optional)</span>
                            </label>
                            <MultiSelectCustomCard
                              data={filters.accountTypeFilters}
                              labelKey="name"
                              valueKey="id"
                              showAccountTypeInLabel={false}
                              selectedValues={selectedAccountType.map(
                                (item) => item.id
                              )}
                              onChange={(ids) => {
                                const selected =
                                  filters.accountTypeFilters.filter((item) =>
                                    ids.includes(item.id)
                                  );
                                setSelectedAccountType(selected);
                                setSelectedMainGroup([]);
                                setSelectedSubGroup1([]);
                                setSelectedSubGroup2([]);
                                setSelectedSubGroup3([]);
                                setSelectedCoa([]);
                              }}
                              placeholder="Filter Account Types"
                              isSearch={false}
                              isSelectAll={false}
                            />
                          </div>
                          <div className="group">
                            <label>
                              Main Group Filter <span>(Optional)</span>
                            </label>
                            <MultiSelectCustomCard
                              data={filteredMainGroups}
                              labelKey="name"
                              valueKey="id"
                              accountType="accountType"
                              showAccountTypeInLabel={true}
                              selectedValues={selectedMainGroup.map(
                                (item) => item.id
                              )}
                              onChange={(ids) => {
                                const selected = filteredMainGroups.filter(
                                  (item) => ids.includes(item.id)
                                );
                                setSelectedMainGroup(selected);
                                setSelectedSubGroup1([]);
                                setSelectedSubGroup2([]);
                                setSelectedSubGroup3([]);
                                setSelectedCoa([]);
                              }}
                              placeholder="Filter Main Groups"
                            />
                          </div>
                          <div className="group">
                            <label>
                              Subgroup 1 Filter <span>(Optional)</span>
                            </label>
                            <MultiSelectCustomCard
                              data={filteredSubGroup1}
                              labelKey="name"
                              valueKey="id"
                              accountType="accountType"
                              showAccountTypeInLabel={true}
                              selectedValues={selectedSubGroup1.map(
                                (item) => item.id
                              )}
                              onChange={(ids) => {
                                const selected = filteredSubGroup1.filter(
                                  (item) => ids.includes(item.id)
                                );
                                setSelectedSubGroup1(selected);
                                setSelectedSubGroup2([]);
                                setSelectedSubGroup3([]);
                                setSelectedCoa([]);
                              }}
                              placeholder="Filter Subgroup 1"
                            />
                          </div>
                          <div className="group">
                            <label>
                              Subgroup 2 Filter <span>(Optional)</span>
                            </label>
                            <MultiSelectCustomCard
                              data={filteredSubGroup2}
                              labelKey="name"
                              valueKey="id"
                              accountType="accountType"
                              showAccountTypeInLabel={true}
                              selectedValues={selectedSubGroup2.map(
                                (item) => item.id
                              )}
                              onChange={(ids) => {
                                const selected = filteredSubGroup2.filter(
                                  (item) => ids.includes(item.id)
                                );
                                setSelectedSubGroup2(selected);
                                setSelectedSubGroup3([]);
                                setSelectedCoa([]);
                              }}
                              placeholder="Filter Subgroup 2"
                            />
                          </div>
                          <div className="group">
                            <label>
                              Subgroup 3 Filter <span>(Optional)</span>
                            </label>
                            <MultiSelectCustomCard
                              data={filteredSubGroup3}
                              labelKey="name"
                              valueKey="id"
                              accountType="accountType"
                              showAccountTypeInLabel={true}
                              selectedValues={selectedSubGroup3.map(
                                (item) => item.id
                              )}
                              onChange={(ids) => {
                                const selected = filteredSubGroup3.filter(
                                  (item) => ids.includes(item.id)
                                );
                                setSelectedSubGroup3(selected);
                                setSelectedCoa([]);
                              }}
                              placeholder="Filter Subgroup 3"
                            />
                          </div>
                          <div className="group">
                            <label>
                              COA Filter <span>(Optional)</span>
                            </label>
                            <MultiSelectCustomCard
                              data={filteredCoa}
                              labelKey="name"
                              valueKey="id"
                              showAccountTypeInLabel={false}
                              selectedValues={selectedCoa.map(
                                (item) => item.id
                              )}
                              onChange={(ids) => {
                                const selected = filteredCoa.filter((item) =>
                                  ids.includes(item.id)
                                );
                                setSelectedCoa(selected);
                              }}
                              placeholder="Filter COAs"
                            />
                          </div>
                          <div className="notification">
                            <div className="notification-header d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z" fill="#065A8C"/>
                                </svg>
                                <h6>Pro Tip</h6>
                                </div>
                                <button>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                  <path d="M12.2005 3.80665C11.9405 3.54665 11.5205 3.54665 11.2605 3.80665L8.00047 7.05998L4.74047 3.79998C4.48047 3.53998 4.06047 3.53998 3.80047 3.79998C3.54047 4.05998 3.54047 4.47998 3.80047 4.73998L7.06047 7.99998L3.80047 11.26C3.54047 11.52 3.54047 11.94 3.80047 12.2C4.06047 12.46 4.48047 12.46 4.74047 12.2L8.00047 8.93998L11.2605 12.2C11.5205 12.46 11.9405 12.46 12.2005 12.2C12.4605 11.94 12.4605 11.52 12.2005 11.26L8.94047 7.99998L12.2005 4.73998C12.4538 4.48665 12.4538 4.05998 12.2005 3.80665Z" fill="#065A8C"/>
                                </svg></button>
                            </div>
                            <div className="body">
                              <p>Not selecting an Account Type will display the sum of your filters if both Expense and Revenue COAs are included.</p>
                            </div>
                          </div>
                        </div>
                      )}
                </div>
              )}
            </div>
          </Col>
          <Col md={9} className="right-panel ">
            <div className="right-panel-header">
              <h6 className="sub-heading">Configure</h6>
            </div>
            <div className="chart-row height-100">
              {activeTab === "custom" ? (
                <div
                  className="right-panel d-flex align-items-center justify-content-center panel-bg"
                >
                  {customMetricListLoading ? (
                    <Spinner animation="border" variant="success" />
                  ) : (
                    <CustomMetricRightPanel
                      selectedMetric={customMatricCards}
                      defaultChartType={chartType}
                      setCardData={setCardData}
                      setOriginalValues={setOriginalValues}
                      metricItem={metricItem}
                    />
                  )}
                </div>
              ) : (
                <div
                  className={`right-panel d-flex align-items-center justify-content-center ${
                    selectedMetric ? "panel-bg" : ""
                  }`}
                >
                  {metricListLoading ? (
                    <Spinner animation="border" variant="success" />
                  ) : (
                    <MetricRightPanel
                      selectedMetric={selectedMetric}
                      defaultChartType={chartType}
                      setCardData={setCardData}
                      setOriginalValues={setOriginalValues}
                      metricItem={metricItem}
                    />
                  )}
                </div>
              )}
            </div>
          </Col>
        </Row>
        {/* Second Row - List & Panel */}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline" onClick={() => closeModal()}>
          Cancel
        </Button>
        <Button
          disabled={
            activeTab !== "custom" && (
              !selectedMetric ||
              !cardData?.chartTitle ||
              (cardData.chartType?.toLowerCase() == "progress" &&
                cardData.chartComparison?.length == 0) ||
              isSubmitting)
          }
          variant="primary"
          onClick={handleAddToDashboard}
        >
          {isMetricEdit ? "Update to Dashboard" : "Add to Dashboard"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default MetricModal;
